module.exports = __webpack_public_path__ + "static/img/ny-banner.3016dcf6.jpg";